class QueryBrowser {
	static execute(queryString) {
		const el = document.querySelector('body');
		const evt = new Event('execute');

		evt.queryString = queryString;

		el.dispatchEvent(evt);
	}
}

export default QueryBrowser;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/QueryBrowser.js